import React, { useEffect } from 'react';
import { Navbar } from '../../components/Navbar';
import { StickyFooter } from '../../components/StickyFooter';
import { ShieldCheckIcon, TruckIcon, CheckCircleIcon } from 'lucide-react';
const EQUIPMENT = [{
  id: 1,
  name: 'Pride Go-Go Mobility Scooter',
  category: 'Mobility',
  daily: '$45',
  weekly: '$180',
  image: 'https://images.unsplash.com/photo-1581594693702-fbdc51b2763b?w=400&auto=format&fit=crop',
  badges: ['Hospital-Grade Sanitization', 'RDU Delivery Available']
}, {
  id: 2,
  name: 'Lightweight Wheelchair',
  category: 'Mobility',
  daily: '$20',
  weekly: '$75',
  image: 'https://images.unsplash.com/photo-1581594693702-fbdc51b2763b?w=400&auto=format&fit=crop',
  badges: ['Hospital-Grade Sanitization', 'Foldable']
}, {
  id: 3,
  name: 'Knee Walker',
  category: 'Mobility',
  daily: '$25',
  weekly: '$90',
  image: 'https://images.unsplash.com/photo-1581594693702-fbdc51b2763b?w=400&auto=format&fit=crop',
  badges: ['Hospital-Grade Sanitization', 'Adjustable']
}, {
  id: 4,
  name: 'Premium Travel Stroller',
  category: 'Baby Gear',
  daily: '$15',
  weekly: '$60',
  image: 'https://images.unsplash.com/photo-1519689680058-324335c77eba?w=400&auto=format&fit=crop',
  badges: ['Sanitized', 'Compact Fold']
}, {
  id: 5,
  name: 'Travel Crib / Pack n Play',
  category: 'Baby Gear',
  daily: '$12',
  weekly: '$50',
  image: 'https://images.unsplash.com/photo-1519689680058-324335c77eba?w=400&auto=format&fit=crop',
  badges: ['Sanitized', 'Includes Sheet']
}];
export function EquipmentRentalsUS() {
  useEffect(() => {
    document.title = "Rent Mobility Scooters, Wheelchairs & Strollers in Raleigh, Durham & RDU | Care Nomad";
  }, []);
  return <div className="min-h-screen w-full bg-gray-50 flex flex-col" data-id="element-2328" data-mp="7ekisns1l87j">
      <Navbar data-id="element-2329" data-mp="7hf2ue758r0f" />
      
      <main className="flex-1" data-id="element-2330" data-mp="cdvxzscrg5n0">
        {/* Hero Section */}
        <section className="w-full bg-[#007a87] py-16 lg:py-24" data-id="element-2331" data-mp="cg9tu3f9llvm">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-2332" data-mp="3pfzs0qaur75h">
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white tracking-tight mb-6" data-id="element-2333" data-mp="3knomn7xcet5j">
              Rent Mobility Scooters, Wheelchairs & Strollers in Raleigh, Durham & RDU
            </h1>
            <p className="text-xl text-white/90 max-w-3xl mx-auto mb-10 leading-relaxed" data-id="element-2334" data-mp="3aqtnqnx5qqqq">
              Premium equipment rentals fulfilled by Care Nomad and authorized partners. Same-day delivery to RDU Airport, Duke/UNC Health, and local hotels.
            </p>
            <div className="flex flex-wrap justify-center gap-6 text-white/90 font-medium" data-id="element-2335" data-mp="2a8ldpz16vwl">
              <span className="flex items-center gap-2" data-id="element-2336" data-mp="2c1tzat7fq78"><ShieldCheckIcon className="w-5 h-5 text-green-300" data-id="element-2337" data-mp="3thbewo2cde9z" /> Hospital-Grade Sanitization</span>
              <span className="flex items-center gap-2" data-id="element-2338" data-mp="2n1isflyktojz"><TruckIcon className="w-5 h-5 text-green-300" data-id="element-2339" data-mp="2myd4wb5liuqd" /> Same-Day Delivery</span>
            </div>
          </div>
        </section>

        {/* Catalog */}
        <section className="py-16" data-id="element-2340" data-mp="xkdh40t84xli">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2341" data-mp="xh97gnwzp9ng">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-2342" data-mp="12j6wjys2myob">
              {EQUIPMENT.map(item => <div key={item.id} className="bg-white rounded-2xl border border-gray-200 overflow-hidden shadow-sm hover:shadow-md transition-shadow flex flex-col" data-id="element-2343" data-mp="17ff70yvbq3p5">
                  <div className="h-48 overflow-hidden relative bg-gray-100" data-id="element-2344" data-mp="1h69x6eboxnfv">
                    <img src={item.image} alt={item.name} className="w-full h-full object-cover" data-id="element-2345" data-mp="1l8dg1o0ovub6" />
                    <div className="absolute top-3 left-3 bg-white/90 backdrop-blur-sm px-3 py-1 rounded-full text-xs font-bold text-[#007a87]" data-id="element-2346" data-mp="1q7houdjpbq0z">
                      {item.category}
                    </div>
                  </div>
                  
                  <div className="p-6 flex-1 flex flex-col" data-id="element-2347" data-mp="3s1h234gdwhgb">
                    <h3 className="font-bold text-xl text-[#1a2332] mb-4" data-id="element-2348" data-mp="u4hefgallvn">{item.name}</h3>
                    
                    <div className="flex justify-between items-center mb-6 pb-6 border-b border-gray-100" data-id="element-2349" data-mp="1r8vmc4ui721c">
                      <div data-id="element-2350" data-mp="1makdnxfy2xkp">
                        <div className="text-sm text-gray-500" data-id="element-2351" data-mp="1mdgb7knvrk8m">Daily Rate</div>
                        <div className="font-bold text-lg text-[#1a2332]" data-id="element-2352" data-mp="20a27ir83l10x">{item.daily}</div>
                      </div>
                      <div className="text-right" data-id="element-2353" data-mp="1w7fdcjnyf40k">
                        <div className="text-sm text-gray-500" data-id="element-2354" data-mp="18kqn9aosk58v">Weekly Rate</div>
                        <div className="font-bold text-lg text-[#1a2332]" data-id="element-2355" data-mp="13l4af2cvkr0l">{item.weekly}</div>
                      </div>
                    </div>

                    <div className="flex flex-wrap gap-2 mb-6" data-id="element-2356" data-mp="1hdahlyy1vnnw">
                      {item.badges.map((badge, idx) => <span key={idx} className="bg-gray-50 text-gray-600 px-2.5 py-1 rounded-md text-xs font-medium flex items-center gap-1.5 border border-gray-100" data-id="element-2357" data-mp="ovoobzoah9r8" data-mpi={idx}>
                          <CheckCircleIcon className="w-3 h-3 text-[#007a87]" data-id="element-2358" data-mp="ktuqs09e4lva" />
                          {badge}
                        </span>)}
                    </div>

                    <a href="/us/book-now" className="mt-auto w-full bg-white border-2 border-[#5a55ea] text-[#5a55ea] hover:bg-[#5a55ea] hover:text-white font-bold py-3 rounded-xl transition-colors flex items-center justify-center text-center" data-id="element-2359" data-mp="fifx7zyg66l3">
                      Book Rental
                    </a>
                  </div>
                </div>)}
            </div>
          </div>
        </section>
      </main>

      <StickyFooter data-id="element-2360" data-mp="ydec70qumdkb" />
    </div>;
}